import React from 'react';
import VoiceLeaderboardContainer from '@src/containers/VoiceLeaderboard';

const VoiceLeaderboard = () => <VoiceLeaderboardContainer />;

export default VoiceLeaderboard;
